/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knowledgebase_LoadingInputs */

const en_knowledgebase_loading = /** @type {(inputs: Knowledgebase_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading knowledgebase...`)
};

const es_knowledgebase_loading = /** @type {(inputs: Knowledgebase_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando base de conocimiento...`)
};

/**
* | output |
* | --- |
* | "Loading knowledgebase..." |
*
* @param {Knowledgebase_LoadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const knowledgebase_loading = /** @type {((inputs?: Knowledgebase_LoadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledgebase_LoadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_knowledgebase_loading(inputs)
	return es_knowledgebase_loading(inputs)
});